import { Injectable, inject } from '@angular/core';
import { AngularFireStorage, AngularFireUploadTask } from '@angular/fire/compat/storage';
import { getDownloadURL, getStorage, deleteObject, listAll } from '@angular/fire/storage';

import { ref } from 'firebase/storage';
import { lastValueFrom } from 'rxjs';
import { ImageMultipleCrops, ImgStorageData, FileStorageData } from '../classes/storage.models';

@Injectable({
  providedIn: 'root',
})
export class MultiImagesStorageService {
  private storage = inject(AngularFireStorage);

  public async uploadImage(image: Blob, path: string): Promise<ImgStorageData> {
    try {
      const refStorage = this.storage.ref(path);
      const task = await refStorage.put(image);
      const { bucket, name: metadataName, contentType, size } = task.metadata;
      const url = await lastValueFrom(refStorage.getDownloadURL());
      const imageStorage: ImgStorageData = {
        url,
        name: metadataName,
        type: contentType,
        size,
      };
      return imageStorage;
    } catch (error) {
      console.error('uploading image error: ', error);
      return null;
    }
  }

  public async delete_directory(imagePath: string): Promise<void> {
    // WARNING!!  user very carefully could delete whatever folder
    const storage = getStorage();
    const directoryRef = ref(storage, imagePath);

    listAll(directoryRef)
      .then((res) => {
        res.items.forEach((itemRef) => {
          console.log(itemRef);
          deleteObject(itemRef);
        });
      })
      .catch((error) => {
        console.error('error al eliminar imagenes de cloud storage', error);
      });
  }

  public async deleteImage(imagePath: string): Promise<void> {
    const storageRef = this.storage.ref(imagePath);
    storageRef.delete().subscribe((res) => {
      console.log('image deleted', res);
    });
  }

  private async uploadAndGetUrl(task: AngularFireUploadTask, resolution: string): Promise<ImgStorageData> {
    const snap = await task;
    const { fullPath, bucket, name, contentType, size } = snap.metadata;
    const storage = getStorage();
    const storageRef = ref(storage, fullPath);
    const url = await getDownloadURL(storageRef);
    const meta: ImgStorageData = {
      url,
      name,
      resolution,
      type: contentType,
      size,
      resolutions: {}, // Default empty resolutions
    };

    return meta;
  }

  public async uploadGenericFile(file: File, storagePath: string, metadata?: any): Promise<FileStorageData | null> {
    try {
      // Ensure storagePath is a directory path, and append file.name
      const fullFilePath = `${storagePath.replace(/\/$/, '')}/${Date.now()}-${file.name}`;
      const refStorage = this.storage.ref(fullFilePath);
      const task = await refStorage.put(file, { customMetadata: metadata });
      const url = await lastValueFrom(refStorage.getDownloadURL());

      const fileData: FileStorageData = {
        url,
        name: file.name,
        type: file.type,
        size: file.size,
        metadata: task.metadata,
      };
      return fileData;
    } catch (error) {
      console.error(`Error uploading file ${file.name} to ${storagePath}:`, error);
      return null;
    }
  }
}
